import { render, staticRenderFns } from "./Votes.vue?vue&type=template&id=270eea5a&scoped=true"
import script from "./Votes.vue?vue&type=script&lang=js"
export * from "./Votes.vue?vue&type=script&lang=js"
import style0 from "./Votes.vue?vue&type=style&index=0&id=270eea5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270eea5a",
  null
  
)

export default component.exports